import React from 'react';
import { Row, Column } from '@grubhubprod/gh-cookbook-react';
import { StartDateControl } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/StartDateControl/StartDateControl';
import { EndDateControl } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/EndDateControl/EndDateControl';

export const DateRangePicker: React.FC = () => {
  return (
    <Row gutter={12}>
      <Column phone={12} tablet={6} gutter={12}>
        <StartDateControl name="startDate" id="startDate" />
      </Column>
      <Column phone={12} tablet={6} gutter={12}>
        <EndDateControl name="endDate" id="endDate" />
      </Column>
    </Row>
  );
};
